import * as React from 'react';
import { InputAdornment } from '@cian/ui-kit';

import * as styles from './Adornment.css';

interface IAdornmentProps {
  children: React.ReactNode;
}

export function Adornment({ children }: IAdornmentProps) {
  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
  };

  return (
    <InputAdornment>
      <div className={styles['adornment']} onMouseDown={handleMouseDown}>
        {children}
      </div>
    </InputAdornment>
  );
}
